export default __webpack_public_path__ + "static/media/greenStatus_icon.f1873233.svg";